import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

const MessageList = ({ isError, messages }) => (
  <div>
    {messages.length > 0 && (
      <Message success={!isError} error={isError} style={{ marginBottom: '10px' }}>
        <Message.List>
          {messages.map(error => <Message.Item key={error}>{error}</Message.Item>)}
        </Message.List>
      </Message>
    )}
  </div>
);

MessageList.propTypes = {
  isError: PropTypes.bool,
  messages: PropTypes.arrayOf(PropTypes.string),
};

MessageList.defaultProps = {
  isError: false,
  messages: [],
};

export default MessageList;



// WEBPACK FOOTER //
// ./src/components/reusable/MessageList.js